// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ICardStatusMultiEmployersSummaryRecordDto } from './ICardStatusMultiEmployersSummaryRecordDto';
import {
    ICardStatusMultiEmployersSummaryRecordDtoFromJSON,
    ICardStatusMultiEmployersSummaryRecordDtoFromJSONTyped,
    ICardStatusMultiEmployersSummaryRecordDtoToJSON,
    ICardStatusMultiEmployersSummaryRecordDtoToJSONTyped,
} from './ICardStatusMultiEmployersSummaryRecordDto';

/**
 * 
 * @export
 * @interface IReportSummaryGroupDtoCardStatusMultiEmployersSummaryRecordDto
 */
export interface IReportSummaryGroupDtoCardStatusMultiEmployersSummaryRecordDto {
    /**
     * 
     * @type {string}
     * @memberof IReportSummaryGroupDtoCardStatusMultiEmployersSummaryRecordDto
     */
    subsidiary_name?: string;
    /**
     * 
     * @type {Array<ICardStatusMultiEmployersSummaryRecordDto>}
     * @memberof IReportSummaryGroupDtoCardStatusMultiEmployersSummaryRecordDto
     */
    subsidiary_records?: Array<ICardStatusMultiEmployersSummaryRecordDto>;
}

/**
 * Check if a given object implements the IReportSummaryGroupDtoCardStatusMultiEmployersSummaryRecordDto interface.
 */
export function instanceOfIReportSummaryGroupDtoCardStatusMultiEmployersSummaryRecordDto(value: object): value is IReportSummaryGroupDtoCardStatusMultiEmployersSummaryRecordDto {
    return true;
}

export function IReportSummaryGroupDtoCardStatusMultiEmployersSummaryRecordDtoFromJSON(json: any): IReportSummaryGroupDtoCardStatusMultiEmployersSummaryRecordDto {
    return IReportSummaryGroupDtoCardStatusMultiEmployersSummaryRecordDtoFromJSONTyped(json, false);
}

export function IReportSummaryGroupDtoCardStatusMultiEmployersSummaryRecordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IReportSummaryGroupDtoCardStatusMultiEmployersSummaryRecordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'subsidiary_name': json['subsidiary_name'] == null ? undefined : json['subsidiary_name'],
        'subsidiary_records': json['subsidiary_records'] == null ? undefined : ((json['subsidiary_records'] as Array<any>).map(ICardStatusMultiEmployersSummaryRecordDtoFromJSON)),
    };
}

export function IReportSummaryGroupDtoCardStatusMultiEmployersSummaryRecordDtoToJSON(json: any): IReportSummaryGroupDtoCardStatusMultiEmployersSummaryRecordDto {
    return IReportSummaryGroupDtoCardStatusMultiEmployersSummaryRecordDtoToJSONTyped(json, false);
}

export function IReportSummaryGroupDtoCardStatusMultiEmployersSummaryRecordDtoToJSONTyped(value?: IReportSummaryGroupDtoCardStatusMultiEmployersSummaryRecordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'subsidiary_name': value['subsidiary_name'],
        'subsidiary_records': value['subsidiary_records'] == null ? undefined : ((value['subsidiary_records'] as Array<any>).map(ICardStatusMultiEmployersSummaryRecordDtoToJSON)),
    };
}

